import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Groups are often confused with `}<a parentName="p" {...{
        "href": "/docs/data/cohorts"
      }}>{`cohorts`}</a>{`, but they each serve different purposes:`}</p>
    <ul>
      <li parentName="ul">{`Groups aggregate events, and do not necessarily have to be connected to a user.`}</li>
      <li parentName="ul">{`Cohorts represent a specific set of users – e.g., a list of users that all belong to the same company.`}</li>
    </ul>
    <p>{`If your only goal is to analyze a `}<strong parentName="p">{`list of users`}</strong>{` with something in common, we recommend `}<a parentName="p" {...{
        "href": "/docs/data/cohorts"
      }}>{`cohorts`}</a>{` instead of groups.`}</p>
    <p>{`Groups require additional code in your app to set up, while cohorts are created in PostHog and don't require additional code. This makes cohorts easier to use and quicker to get started. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      